export default {
  isShowRequestLoading: '',
  isEn: false,
};
